import { enableOutOfTheBoxRoles, isNoAccessRoleEnabled } from '@gonfalon/dogfood-flags/dogfood-flags';
import { capitalize } from '@gonfalon/strings/capitalize';

import type { RoleName } from '../internal/types';

const BASIC_ROLES: RoleName[] = [
  ...(enableOutOfTheBoxRoles() ? ['owner' as const] : []),
  'admin',
  'writer',
  'reader',
  ...(isNoAccessRoleEnabled() ? ['no_access' as const] : []),
];

export const formattedRoleName = (role: RoleName) => capitalize(role.replace('_', ' '));

export const roleDescription = (role: RoleName) => {
  switch (role) {
    case 'no_access':
      return "Can't read or modify anything until assigned another role or to a team";
    case 'reader':
      return "Can read everything, but can't modify anything.";
    case 'writer':
      return "Can read everything and make changes to the platform, but can't manage account members, billing details or change the account owner";
    case 'admin':
      return "Can read and modify anything but can't change the account owner.";
    case 'owner':
      return enableOutOfTheBoxRoles()
        ? 'Can also add or remove the Admin role and the Owner role from other members. Only one member can have this role.'
        : '';
    case 'custom':
      return "Members will have specific custom roles that you'll assign below";
    default:
      return '';
  }
};

export const samlRoleDescription = (role: RoleName) => {
  switch (role) {
    case 'no_access':
      return "Members won't be able to read or modify anything until assigned another role or to a team";
    case 'reader':
      return "Members will be able to read everything, but won't be able to modify anything until assigned another role or to a team";
    case 'custom':
      return "Members will have a specific custom role that you'll assign below";
    default:
      return '';
  }
};

export const simpleRoles = Object.freeze(BASIC_ROLES);
